import { Backdrop, CircularProgress } from "@material-ui/core";

const ProgressLoader = ({ isOpen = true }: { isOpen: boolean }) => {
  return (
    <Backdrop open={isOpen} style={{ zIndex: 1 }}>
      <CircularProgress color="primary" />
    </Backdrop>
  );
};

export default ProgressLoader;
